import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ChangeGesturePage } from './change-gesture.page';

const routes: Routes = [
  {
    path: '',
    component: ChangeGesturePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChangeGesturePageRoutingModule {}
